import { ParameterType } from '@/study-search/enums';

import { FilterDefinition } from '../FilterDefinition';
import { FilterOptionInformation } from '@studyportals/search-filters';
import { SpecialProgrammesFilterOptionValue } from '@studyportals/search-filters/server-side';

class DistanceLearningSpecialProgrammesFilterDefinition extends FilterDefinition {
	public constructor() {
		super(
			ParameterType.SPECIAL_PROGRAMMES,
			[new FilterOptionInformation('Executive Programmes', SpecialProgrammesFilterOptionValue.EXECUTIVE_PROGRAMMES, '', '')],
			[],
		);
	}
}

export default new DistanceLearningSpecialProgrammesFilterDefinition();
